import { Controller } from "@hotwired/stimulus"

// A wannabrunch partner card and its detail modal. Scoped to the pair, so a
// list of partners is a list of independent controllers with no ids to match
// up. Open/close mirror lib/modals.js — `flex`, then `modal-visible` on the
// next frame to trigger the 200ms CSS transition, and the reverse on the way
// out — rather than importing it, because the map needs the same hook.
//
// The map is a place-map controller on the `map` target, built the first time
// the modal opens: a page lists a dozen partners and none of their maps should
// cost a tile until someone asks for one — and MapLibre could not measure the
// box while it was display:none anyway. This controller knows nothing about
// MapLibre; it only says "you can be seen now", after the overlay is shown.
export default class extends Controller {
  static targets = ["overlay", "map"]

  open() {
    this.overlayTarget.classList.remove("hidden")
    this.overlayTarget.classList.add("flex")
    if (this.hasMapTarget) this.mapTarget.dispatchEvent(new CustomEvent("place-map:show"))
    requestAnimationFrame(() => this.overlayTarget.classList.add("modal-visible"))

    // The overlay scrolls on its own; letting the page scroll behind it means
    // closing the modal leaves you somewhere else than where you opened it.
    document.body.classList.add("overflow-hidden")
    this.escHandler = (event) => { if (event.key === "Escape") this.close() }
    document.addEventListener("keydown", this.escHandler)
  }

  close() {
    this.stopListening()
    document.body.classList.remove("overflow-hidden")
    this.overlayTarget.classList.remove("modal-visible")
    setTimeout(() => {
      this.overlayTarget.classList.add("hidden")
      this.overlayTarget.classList.remove("flex")
    }, 200)
  }

  // Clicks on the panel bubble up to the overlay; only the overlay itself is
  // the backdrop.
  backdrop(event) { if (event.target === this.overlayTarget) this.close() }

  disconnect() {
    this.stopListening()
    document.body.classList.remove("overflow-hidden")
  }

  stopListening() {
    if (!this.escHandler) return
    document.removeEventListener("keydown", this.escHandler)
    this.escHandler = null
  }
}
